const WEEKLY_COMMON_MISSION_TYPE = [
  {
    id: 0,
    contract: "BasicCrime",
    messageType: "BasicCrime",
    messageSubType: "Hotdog",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Rob a hotdog stand",
    description:
      "A simple street crime to earn some quick cash. The vendor won't see it coming, but stay alert for witnesses.",
    cashMultiplier: 1,
    link: "/crimes",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/rob-hotdog.png",
  },
  {
    id: 1,
    contract: "BasicCrime",
    messageType: "BasicCrime",
    messageSubType: "Train",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Rob a freight train",
    description:
      "Pull off a daring freight train heist. Timing is everything as you board the moving cargo and grab valuable goods before the guards respond.",
    cashMultiplier: 1.3,
    link: "/crimes",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/rob-train.png",
  },
  {
    id: 2,
    contract: "BasicCrime",
    messageType: "BasicCrime",
    messageSubType: "Bank",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Rob the bank",
    description:
      "The ultimate heist. Navigate through security systems, avoid alarms, and crack the vault for a massive payday. High risk, high reward.",
    cashMultiplier: 1.3,
    link: "/crimes",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/rob-bank.png",
  },
  {
    id: 3,
    contract: "BasicCrime",
    messageType: "BasicCrime",
    messageSubType: "PoliceStation",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Bribe the police station",
    description:
      "Corruption runs deep. Pay off the right officers to look the other way and keep your operations running smoothly without interference.",
    cashMultiplier: 1.5,
    link: "/crimes",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/bribe-police.png",
  },
  {
    id: 4,
    contract: "CarNick",
    messageType: "CarNick",
    messageSubType: "StreetCorner",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Steal car from the street corner",
    description:
      "Boost an unattended vehicle from a quiet street corner. Quick and easy work for a skilled car thief.",
    cashMultiplier: 1.2,
    link: "/nickcar",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/nick-car-street-corner.png",
  },
  {
    id: 5,
    contract: "CarNick",
    messageType: "CarNick",
    messageSubType: "FootballStadium",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Steal car from the football stadium",
    description:
      "Hit the stadium parking lot during game time. With everyone watching the match, these luxury vehicles are easy pickings.",
    cashMultiplier: 1.3,
    link: "/nickcar",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/nick-car-stadium.png",
  },
  {
    id: 6,
    contract: "CarNick",
    messageType: "CarNick",
    messageSubType: "PrivateResidence",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Steal car from private residence",
    description:
      "Break into a wealthy neighborhood and snatch a high-end vehicle from someone's driveway. Watch out for security cameras and nosy neighbors.",
    cashMultiplier: 1.4,
    link: "/nickcar",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/nick-car-private-residence.png",
  },
  {
    id: 7,
    contract: "CarNick",
    messageType: "CarNick",
    messageSubType: "Dealership",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Steal car from the dealership",
    description:
      "The most audacious car theft. Bypass dealership security and drive off with a brand new luxury vehicle straight from the showroom floor.",
    cashMultiplier: 1.5,
    link: "/nickcar",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/nick-car-dealership.png",
  },
  {
    id: 8,
    contract: "Jail",
    messageType: "Jail",
    messageSubType: "BustOut",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "prisonerAddress",
    title: "Bust out a player",
    description:
      "Break one of your crew members out of jail. Plan the escape carefully and get them out before they serve their full sentence.",
    cashMultiplier: 1.1,
    link: "/jail",
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/jail.webp",
  },
  {
    id: 9,
    contract: "KillSkill",
    messageType: "KillSkill",
    messageSubType: "Train",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Train kill skill",
    description:
      "Sharpen your assassination techniques at the training facility. Practice makes perfect when lives are on the line.",
    cashMultiplier: 1.5,
    link: "/killskill",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/killskill-bottles.png",
  },
  {
    id: 10,
    contract: "Jail",
    messageType: "Jail",
    messageSubType: "Imprison",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Get caught",
    description:
      "Sometimes you get caught. Serve your time or wait for someone to bust you out. It's all part of the game.",
    cashMultiplier: 1,
    link: "",
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/jail.webp",
  },
  {
    id: 11,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Chicago by train",
    description:
      "Take the rails to the Windy City. Chicago's underworld awaits with new opportunities and connections to explore.",
    cashMultiplier: 1.1,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel.webp",
  },
  {
    id: 12,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 4,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Las Vegas by train",
    description:
      "Journey to Sin City by rail. The casinos, rackets, and high-stakes deals of Vegas are calling your name.",
    cashMultiplier: 1.1,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel.webp",
  },
  {
    id: 13,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 1,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Detroit by train",
    description:
      "Head to Motor City by train. Detroit's industrial landscape offers unique criminal opportunities in the automotive trade.",
    cashMultiplier: 1.1,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel.webp",
  },
  {
    id: 14,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 3,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Miami by train",
    description:
      "Ride the rails to the Magic City. Miami's beaches hide a thriving underworld of smuggling and illicit trade.",
    cashMultiplier: 1.1,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel.webp",
  },
  {
    id: 15,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 2,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to New York by train",
    description:
      "Take the train to the Big Apple. New York's five families control the most lucrative territory in the country.",
    cashMultiplier: 1.1,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel.webp",
  },
  {
    id: 16,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 7,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Caracas by train",
    description:
      "Journey south to Venezuela's capital. Caracas is a hub for international smuggling operations and cartel connections.",
    cashMultiplier: 1.1,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel.webp",
  },
  {
    id: 17,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 5,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Medellin by train",
    description:
      "Head to Colombia's cartel heartland. Medellin offers connections to some of the most powerful drug trafficking networks.",
    cashMultiplier: 1.1,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel.webp",
  },
  {
    id: 18,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 6,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Bogota by train",
    description:
      "Travel to Colombia's capital by rail. Bogota is the central hub for narcotics distribution throughout South America.",
    cashMultiplier: 1.1,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel.webp",
  },
  {
    id: 19,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 10,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Napoli by train",
    description:
      "Journey to Napoli, home of the Camorra. The Italian port city is steeped in organized crime tradition and history.",
    cashMultiplier: 1.1,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel.webp",
  },
  {
    id: 20,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 8,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Palermo by train",
    description:
      "Head to Sicily's capital, the birthplace of the Mafia. Palermo's ancient families still control much of Italy's underworld.",
    cashMultiplier: 1.1,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel.webp",
  },
  {
    id: 21,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 9,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Messina by train",
    description:
      "Take the train to Sicily's eastern port. Messina's strategic location makes it perfect for smuggling operations across the Mediterranean.",
    cashMultiplier: 1.1,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel.webp",
  },
  {
    id: 22,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Chicago by plane",
    description:
      "Fly into Chicago for urgent business. Air travel gets you there fast when time is money.",
    cashMultiplier: 1.2,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel7.webp",
  },
  {
    id: 23,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 4,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Las Vegas by plane",
    description:
      "Take a private flight to Vegas. The casinos won't wait, and neither should you.",
    cashMultiplier: 1.2,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel7.webp",
  },
  {
    id: 24,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 1,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Detroit by plane",
    description:
      "Fly to Motor City for quick business in the automotive underworld. Speed is essential for this operation.",
    cashMultiplier: 1.2,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel7.webp",
  },
  {
    id: 25,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 3,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Miami by plane",
    description:
      "Catch a flight to Miami's shores. High-value smuggling deals await at the coastal city's ports.",
    cashMultiplier: 1.2,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel7.webp",
  },
  {
    id: 26,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 2,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to New York by plane",
    description:
      "Fly into the Big Apple for high-stakes meetings. New York business requires a swift arrival.",
    cashMultiplier: 1.2,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel7.webp",
  },
  {
    id: 27,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 7,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Caracas by plane",
    description:
      "Fly south to Caracas for international cartel negotiations. Speed and discretion are paramount.",
    cashMultiplier: 1.2,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel7.webp",
  },
  {
    id: 28,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 5,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Medellin by plane",
    description:
      "Take a charter flight to cartel territory. Medellin deals require quick turnaround times.",
    cashMultiplier: 1.2,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel7.webp",
  },
  {
    id: 29,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 6,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Bogota by plane",
    description:
      "Fly into Bogota's distribution hub. When millions are at stake, you can't afford delays.",
    cashMultiplier: 1.2,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel7.webp",
  },
  {
    id: 30,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 10,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Napoli by plane",
    description:
      "Take a flight to Napoli for urgent Camorra business. The families expect punctuality.",
    cashMultiplier: 1.2,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel7.webp",
  },
  {
    id: 31,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 8,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Palermo by plane",
    description:
      "Fly to Palermo to meet with Sicily's most powerful families. Show respect by arriving quickly.",
    cashMultiplier: 1.2,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel7.webp",
  },
  {
    id: 32,
    contract: "MafiaProfile",
    messageType: "MafiaProfile",
    messageSubType: "Travel",
    isCitySpecific: true,
    cityId: 9,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "travelType",
    title: "Travel to Messina by plane",
    description:
      "Charter a flight to Messina. The port city's smuggling operations require your immediate attention.",
    cashMultiplier: 1.2,
    link: "/travel",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/travel7.webp",
  },
  {
    id: 33,
    contract: "RaceLobby",
    messageType: "RaceLobby",
    messageSubType: "JoinRace",
    isCitySpecific: true,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Win a race in Chicago",
    description:
      "Prove your driving skills on Chicago's streets. Cross the finish line first and claim the prize money.",
    cashMultiplier: 1.5,
    link: "/racing",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/race3.webp",
  },
  {
    id: 34,
    contract: "RaceLobby",
    messageType: "RaceLobby",
    messageSubType: "JoinRace",
    isCitySpecific: true,
    cityId: 4,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Win a race in Las Vegas",
    description:
      "Dominate the Vegas Strip in a high-stakes street race. The fastest driver takes home the jackpot.",
    cashMultiplier: 1.5,
    link: "/racing",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/race3.webp",
  },
  {
    id: 35,
    contract: "RaceLobby",
    messageType: "RaceLobby",
    messageSubType: "JoinRace",
    isCitySpecific: true,
    cityId: 1,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Win a race in Detroit",
    description:
      "Show Detroit what you're made of. Win the street race and establish your reputation in Motor City.",
    cashMultiplier: 1.5,
    link: "/racing",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/race3.webp",
  },
  {
    id: 36,
    contract: "RaceLobby",
    messageType: "RaceLobby",
    messageSubType: "JoinRace",
    isCitySpecific: true,
    cityId: 3,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Win a race in Miami",
    description:
      "Burn rubber on Miami's Ocean Drive. Outpace the competition and win the underground street race.",
    cashMultiplier: 1.5,
    link: "/racing",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/race3.webp",
  },
  {
    id: 37,
    contract: "RaceLobby",
    messageType: "RaceLobby",
    messageSubType: "JoinRace",
    isCitySpecific: true,
    cityId: 2,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Win a race in New York",
    description:
      "Navigate the concrete jungle at breakneck speed. Win the race through New York's busy streets.",
    cashMultiplier: 1.5,
    link: "/racing",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/race3.webp",
  },
  {
    id: 38,
    contract: "RaceLobby",
    messageType: "RaceLobby",
    messageSubType: "JoinRace",
    isCitySpecific: true,
    cityId: 7,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Win a race in Caracas",
    description:
      "Race through Caracas' dangerous streets. Victory here earns respect from the local cartels.",
    cashMultiplier: 1.5,
    link: "/racing",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/race3.webp",
  },
  {
    id: 39,
    contract: "RaceLobby",
    messageType: "RaceLobby",
    messageSubType: "JoinRace",
    isCitySpecific: true,
    cityId: 5,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Win a race in Medellin",
    description:
      "Take on Medellin's mountain roads at high speed. The cartel bosses are watching this race closely.",
    cashMultiplier: 1.5,
    link: "/racing",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/race3.webp",
  },
  {
    id: 40,
    contract: "RaceLobby",
    messageType: "RaceLobby",
    messageSubType: "JoinRace",
    isCitySpecific: true,
    cityId: 6,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Win a race in Bogota",
    description:
      "Conquer Bogota's challenging street circuit. A win here opens doors to Colombia's elite racing scene.",
    cashMultiplier: 1.5,
    link: "/racing",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/race3.webp",
  },
  {
    id: 41,
    contract: "RaceLobby",
    messageType: "RaceLobby",
    messageSubType: "JoinRace",
    isCitySpecific: true,
    cityId: 10,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Win a race in Napoli",
    description:
      "Race through Napoli' historic streets. Victory proves your worth to the Italian crime families.",
    cashMultiplier: 1.5,
    link: "/racing",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/race3.webp",
  },
  {
    id: 42,
    contract: "RaceLobby",
    messageType: "RaceLobby",
    messageSubType: "JoinRace",
    isCitySpecific: true,
    cityId: 8,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Win a race in Palermo",
    description:
      "Dominate Palermo's winding coastal roads. The Sicilian families honor speed and skill above all.",
    cashMultiplier: 1.5,
    link: "/racing",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/race3.webp",
  },
  {
    id: 43,
    contract: "RaceLobby",
    messageType: "RaceLobby",
    messageSubType: "JoinRace",
    isCitySpecific: true,
    cityId: 9,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Win a race in Messina",
    description:
      "Speed through Messina's port district. Winning this race solidifies your status in Sicily.",
    cashMultiplier: 1.5,
    link: "/racing",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/race3.webp",
  },
  {
    id: 44,
    contract: "RaceLobby",
    messageType: "RaceLobby",
    messageSubType: "JoinRace",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: false,
    shouldFail: true,
    extraDataNeeded: false,
    extraData: "",
    title: "Lose a race",
    description:
      "Sometimes you need to throw a race. Take the dive and collect your payoff from the bookies.",
    cashMultiplier: 1.2,
    link: "/racing",
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/race.webp",
  },
  {
    id: 45,
    contract: "RaceLobby",
    messageType: "RaceLobby",
    messageSubType: "JoinRace",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: false,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Join a race",
    description:
      "Enter the street racing scene. Whether you win or lose, participating builds your reputation.",
    cashMultiplier: 1.2,
    link: "/racing",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/race2.webp",
  },
  {
    id: 46,
    contract: "Jackpot",
    messageType: "Jackpot",
    messageSubType: "Winner",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Win a Jackpot round",
    description:
      "Strike it rich at the Jackpot. Beat the odds and walk away with a massive payout from the casino.",
    cashMultiplier: 1.5,
    link: "/jackpot",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/casino.webp",
  },
  {
    id: 47,
    contract: "Roulette",
    messageType: "Roulette",
    messageSubType: "Winner",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "betAmount, winAmount",
    title: "Win 10x on roulette",
    description:
      "Make a bold bet on the roulette wheel and score a 10x payout. High risk brings high rewards.",
    cashMultiplier: 1.4,
    link: "/roulette",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/casino.webp",
  },
  {
    id: 48,
    contract: "SlotMachine",
    messageType: "SlotMachine",
    messageSubType: "Winner",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "betAmount, winAmount",
    title: "Win 10x on slot machine",
    description:
      "Hit the jackpot on the slots. Line up the symbols for a 10x multiplier and watch your winnings soar.",
    cashMultiplier: 1.4,
    link: "/slotmachine",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/casino.webp",
  },
  {
    id: 49,
    contract: "Roulette",
    messageType: "Roulette",
    messageSubType: "Winner",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "betAmount, winAmount",
    title: "Win 5x on roulette",
    description:
      "Place your chips and spin to win. A solid 5x payout keeps you in the game with style.",
    cashMultiplier: 1.2,
    link: "/roulette",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/casino.webp",
  },
  {
    id: 50,
    contract: "SlotMachine",
    messageType: "SlotMachine",
    messageSubType: "Winner",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "betAmount, winAmount",
    title: "Win 5x on slot machine",
    description:
      "Pull the lever and multiply your bet by 5. Even modest wins add up fast in the casino.",
    cashMultiplier: 1.2,
    link: "/slotmachine",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/casino.webp",
  },
  {
    id: 51,
    contract: "Shop",
    messageType: "Shop",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Buy from the shop",
    description:
      "Visit the black market shop and purchase equipment. Every mobster needs the right tools for the job.",
    cashMultiplier: 1.1,
    link: "/shop",
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/shop.webp",
  },
  {
    id: 52,
    contract: "Shop",
    messageType: "Shop",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "categoryId, typeId",
    title: "Buy a grenade",
    description:
      "Stock up on explosives. Grenades are perfect for sending a message or clearing out rival hideouts.",
    cashMultiplier: 1.1,
    link: "/shop",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buygun.webp",
  },
  {
    id: 53,
    contract: "Shop",
    messageType: "Shop",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "categoryId, typeId",
    title: "Buy a Remington",
    description:
      "Acquire a Remington shotgun. This classic firearm is reliable and devastating at close range.",
    cashMultiplier: 1.2,
    link: "/shop",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buygun.webp",
  },
  {
    id: 54,
    contract: "Shop",
    messageType: "Shop",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "categoryId, typeId",
    title: "Buy a gun",
    description:
      "Purchase a firearm from the shop. In this business, you can never have too much firepower.",
    cashMultiplier: 1.1,
    link: "/shop",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buygun.webp",
  },
  {
    id: 55,
    contract: "Shop",
    messageType: "Shop",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "categoryId, typeId",
    title: "Buy a motorcycle",
    description:
      "Get yourself a fast bike. Motorcycles are perfect for quick getaways and navigating city traffic.",
    cashMultiplier: 1.2,
    link: "/shop",
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/shop.webp",
  },
  {
    id: 56,
    contract: "Shop",
    messageType: "Shop",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "categoryId, typeId",
    title: "Buy a Molotov cocktail",
    description:
      "Pick up some Molotov cocktails. These firebombs are cheap, effective, and send a clear message.",
    cashMultiplier: 1.1,
    link: "/shop",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buygun.webp",
  },
  {
    id: 57,
    contract: "Shop",
    messageType: "Shop",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "categoryId, typeId",
    title: "Buy a bulletproof vest",
    description:
      "Invest in protection. A bulletproof vest could save your life when a deal goes south.",
    cashMultiplier: 1.3,
    link: "/shop",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buygun.webp",
  },
  {
    id: 58,
    contract: "Shop",
    messageType: "Shop",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "categoryId, typeId",
    title: "Hire a bodyguard",
    description:
      "Recruit a trained bodyguard. Having muscle at your side deters enemies and protects your interests.",
    cashMultiplier: 1.7,
    link: "/shop",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/mobsters-2.webp",
  },
  {
    id: 59,
    contract: "Exchange",
    messageType: "Exchange",
    messageSubType: "CompleteOTC",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Complete an OTC deal",
    description:
      "Finalize an over-the-counter transaction on the exchange. Private deals often yield better profits than public markets.",
    cashMultiplier: 1.2,
    link: "/exchange/trade",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/market.webp",
  },
  {
    id: 60,
    contract: "Exchange",
    messageType: "Exchange",
    messageSubType: "ConvertTile",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "categoryId, typeId",
    title: "Convert a tile",
    description:
      "Transform your property tiles through the exchange. Converting tiles can unlock new opportunities and increase their value.",
    cashMultiplier: 1.5,
    link: "/exchange/convert",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/market.webp",
  },
  {
    id: 61,
    contract: "Marketplace",
    messageType: "Marketplace",
    messageSubType: "List",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "itemId",
    title: "List on marketplace",
    description:
      "Put an item up for sale on the underground marketplace. One man's trash is another man's treasure.",
    cashMultiplier: 1.2,
    link: "/market",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/market2.webp",
  },
  {
    id: 62,
    contract: "Marketplace",
    messageType: "Marketplace",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "itemId",
    title: "Buy from marketplace",
    description:
      "Purchase an item from the underground marketplace. Smart shopping can save you money and get you rare items.",
    cashMultiplier: 1.2,
    link: "/market",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/market2.webp",
  },
  {
    id: 63,
    contract: "BodyguardTraining",
    messageType: "BodyguardTraining",
    messageSubType: "Train",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Train a bodyguard",
    description:
      "Improve your bodyguard's combat skills through intensive training. Better training means better protection in dangerous situations.",
    cashMultiplier: 1.5,
    link: "/bodyguard",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/mobsters-2.webp",
  },
  {
    id: 64,
    contract: "Inventory",
    messageType: "Inventory",
    messageSubType: "RepairCar",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "itemId",
    title: "Repair a car",
    description:
      "Fix up a damaged vehicle in your garage. A well-maintained fleet keeps you mobile and ready for action.",
    cashMultiplier: 1.2,
    link: "/garage",
  },
  {
    id: 65,
    contract: "GameBank",
    messageType: "GameBank",
    messageSubType: "Transfer",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "from, to, amount",
    title: "Make a bank transfer",
    description:
      "Move money through the banking system. Transfers help you manage finances and pay off debts or allies.",
    cashMultiplier: 1.1,
    link: "/bank",
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/bank.webp",
  },
  {
    id: 66,
    contract: "Hospital",
    messageType: "Hospital",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "price, amount",
    title: "Buy blood under 3000",
    description:
      "Purchase blood bags from the hospital for under 3000. Healing supplies keep you alive in this dangerous business.",
    cashMultiplier: 1.2,
    link: "/hospital",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buy-health.jpg",
  },
  {
    id: 67,
    contract: "Hospital",
    messageType: "Hospital",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "price, amount",
    title: "Buy blood under 2000",
    description:
      "Get a good deal on blood bags for under 2000. Finding affordable medical supplies saves cash for other operations.",
    cashMultiplier: 1.3,
    link: "/hospital",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buy-health.jpg",
  },
  {
    id: 68,
    contract: "Hospital",
    messageType: "Hospital",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "price, amount",
    title: "Buy blood under 1500",
    description:
      "Score an excellent price on blood bags for under 1500. The best deals require patience and timing.",
    cashMultiplier: 1.4,
    link: "/hospital",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buy-health.jpg",
  },
  {
    id: 69,
    contract: "BulletFactory",
    messageType: "BulletFactory",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "price, amount",
    title: "Buy bullets under 600",
    description:
      "Purchase ammunition from the bullet factory for under 600. Stock up when prices are right.",
    cashMultiplier: 1.1,
    link: "/bullet/factory",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buy-bullets.jpg",
  },
  {
    id: 70,
    contract: "BulletFactory",
    messageType: "BulletFactory",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "price, amount",
    title: "Buy bullets under 400",
    description:
      "Get a solid deal on bullets for under 400. Ammunition is essential - never run out during a firefight.",
    cashMultiplier: 1.3,
    link: "/bullet/factory",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buy-bullets.jpg",
  },
  {
    id: 71,
    contract: "BulletFactory",
    messageType: "BulletFactory",
    messageSubType: "Buy",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "price, amount",
    title: "Buy bullets under 300",
    description:
      "Score an excellent bulk deal on ammunition for under 300. Smart buyers wait for the best prices.",
    cashMultiplier: 1.5,
    link: "/bullet/factory",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buy-bullets.jpg",
  },
  {
    id: 72,
    contract: "Equipment",
    messageType: "Equipment",
    messageSubType: "Update",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Update your equipment",
    description:
      "Refresh your loadout with better gear. Staying equipped with the latest weapons and armor keeps you ahead of the competition.",
    cashMultiplier: 1,
    link: "/equipment",
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buyshop.webp",
  },
  {
    id: 73,
    contract: "PerkManager",
    messageType: "PerkManager",
    messageSubType: "Activate",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "itemId",
    title: "Activate a perk",
    description:
      "Unlock special abilities by activating a perk. Perks give you powerful advantages in combat and crime.",
    cashMultiplier: 1.3,
    link: "/perks",
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buyshop.webp",
  },
  {
    id: 74,
    contract: "Inventory",
    messageType: "Inventory",
    messageSubType: "OpenCrate",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "itemId",
    title: "Open a crate",
    description:
      "Crack open a loot crate to discover rare items and rewards. You never know what treasures might be inside.",
    cashMultiplier: 1.7,
    link: "/crate",
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/cash.webp",
  },
  {
    id: 75,
    contract: "HelperBot",
    messageType: "HelperBot",
    messageSubType: "StartBot",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "botType, creditsAmount",
    title: "Start helper bot (100 credits)",
    description:
      "Deploy an automated helper bot with 100 credits. Let technology handle the grind while you focus on bigger operations.",
    cashMultiplier: 1.2,
    link: "/helper",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/helperbot-booze.png",
  },
  {
    id: 76,
    contract: "HelperBot",
    messageType: "HelperBot",
    messageSubType: "StartBot",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "botType, creditsAmount",
    title: "Start helper bot (300 credits)",
    description:
      "Launch a premium helper bot with 300 credits. Higher investment means better returns and efficiency.",
    cashMultiplier: 1.3,
    link: "/helper",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/helperbot-bullets.png",
  },
  {
    id: 77,
    contract: "HelperBot",
    messageType: "HelperBot",
    messageSubType: "StartBot",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "botType, creditsAmount",
    title: "Start helper bot (500 credits)",
    description:
      "Activate an elite helper bot with 500 credits. Maximum automation for maximum profit potential.",
    cashMultiplier: 1.4,
    link: "/helper",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/helperbot-cars.png",
  },
  {
    id: 78,
    contract: "Map",
    messageType: "Map",
    messageSubType: "UpgradeSlot",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Upgrade a building",
    description:
      "Invest in your territory by upgrading a building. Better infrastructure generates more income and influence.",
    cashMultiplier: 1.5,
    link: "/map",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/scenery.webp",
  },
  {
    id: 79,
    contract: "Map",
    messageType: "Map",
    messageSubType: "ClaimSlot",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "",
    title: "Claim a map tile",
    description:
      "Expand your empire by claiming new territory on the map. Control more land to increase your power and wealth.",
    cashMultiplier: 1.5,
    link: "/map",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/scenery.webp",
  },
  {
    id: 80,
    contract: "Deposit",
    messageType: "Deposit",
    messageSubType: "BuyCash",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "cashAmount",
    title: "Buy cash (50,000 min)",
    description:
      "Purchase at least 50,000 in game cash from the exchange. Sometimes you need liquid capital fast.",
    cashMultiplier: 1.1,
    link: "/exchange",
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/cash.webp",
  },
  {
    id: 81,
    contract: "Deposit",
    messageType: "Deposit",
    messageSubType: "BuyCash",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "cashAmount",
    title: "Buy cash (150,000 min)",
    description:
      "Make a substantial purchase of 150,000+ in game cash. Big money moves require big investments.",
    cashMultiplier: 1.2,
    link: "/exchange",
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/cash.webp",
  },
  {
    id: 82,
    contract: "Deposit",
    messageType: "Deposit",
    messageSubType: "BuyCash",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "cashAmount",
    title: "Buy cash (250,000 min)",
    description:
      "Go big with a 250,000+ cash purchase. High rollers need deep pockets for their ambitious plans.",
    cashMultiplier: 1.2,
    link: "/exchange",
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/cash.webp",
  },
  {
    id: 83,
    contract: "Deposit",
    messageType: "Deposit",
    messageSubType: "AddLiquidity",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "cashAmount",
    title: "Sell cash (100,000 min)",
    description:
      "List at least 100,000 in cash for sale. Providing liquidity to others can be profitable.",
    cashMultiplier: 1,
    link: "/exchange/withdraw",
    image: "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/cash.webp",
  },
  {
    id: 84,
    contract: "PerkMinter",
    messageType: "PerkMinter",
    messageSubType: "BuyPerk",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "perkAmount",
    title: "Buy a perk box",
    description:
      "Purchase a mystery perk box from the exchange. Inside could be powerful abilities to enhance your criminal empire.",
    cashMultiplier: 1.2,
    link: "/exchange/perkBox",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buisness.webp",
  },
  {
    id: 85,
    contract: "OGCrateMinter",
    messageType: "CrateMinter",
    messageSubType: "BuyKey",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: false,
    extraData: "keyAmount",
    title: "Buy a key",
    description:
      "Acquire a key to unlock exclusive OG crates. Keys are the gateway to premium loot and rare rewards.",
    cashMultiplier: 1.5,
    link: "/exchange/keys",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buisness.webp",
  },
  {
    id: 86,
    contract: "GICredit",
    messageType: "GICredit",
    messageSubType: "BuyCredit",
    isCitySpecific: false,
    cityId: 0,
    shouldSuccess: true,
    shouldFail: false,
    extraDataNeeded: true,
    extraData: "creditAmount",
    title: "Buy 5 GI credits",
    description:
      "Purchase 5 GI credits to power up your operations. These premium credits unlock advanced features and automation.",
    cashMultiplier: 1.7,
    link: "/gicredit/history",
    image:
      "https://mafia.sfo3.cdn.digitaloceanspaces.com/new-images/buisness.webp",
  },
];

export const WEEKLY_SMUGGLE_TYPE = {
  BOOZE: 0,
  NARCS: 1,
};

export const WEEKLY_SMUGGLE_MISSION_TYPE = {
  Sell: 0,
  Buy: 1,
};

export default WEEKLY_COMMON_MISSION_TYPE;
